<template>
  <myhead @next="next">{{ $route.query.title || $route.meta.title }}</myhead>
  <div class="size18 b600  pady15 ml15">问题提交</div>
  <div class="ml14 mr14">
    <van-field left-icon="edit" maxlength="200" class="BGf5 Cccc pad15 radius8" v-model.trim="content" type="textarea" rows="6" autosize
      placeholder="您在使用中出现的问题，请在这里告诉我们。" show-word-limit />
    <div class="BGwhite pad12 mb10">
      <p class="b500">图片描述</p>
      <van-uploader v-model="fileList" multiple />
    </div>
    <div class="flex right mt15">
      <van-button round type="primary" class="width120px" @click="sub">提交</van-button>
    </div>
  </div>
</template>

<script>
import ajax from "@/utils/request.js";
import { showToast } from 'vant'
export default {
  name: "Home",
  data () {
    return {
      content: "",
      file: "",
      fileList: [],//图片列表
    };
  },
  watch: {},
  methods: {
     sub () {
      if (!this.content) {
        showToast("请填写发现！");
        return; // 终止函数执行
      }
      // const that = this;
      const data = {
        content: this.content,
        imgs: [] // 用于存储图片链接的数组
      };

      if (this.fileList.length > 0) {
        const uploadPromises = this.fileList.map((item) => {
          return ajax.post("api/dyuploadimg", { file: item.file })
            .then((res) => {
              data.imgs.push(res.data.url);
            });
        });

        // 使用 Promise.all 等待所有图片上传操作完成
        Promise.all(uploadPromises)
          .then(() => {
            ajax.post("bug/addbug", data)
              .then((res) => {
                showToast(res.message);
                this.content = ''
                this.fileList = []
              });
          })
          .catch((error) => {
            console.error("图片上传失败:", error);
            // 处理图片上传失败的情况
          });
      } else {
        ajax.post("bug/addbug", data)
          .then((res) => {
            showToast(res.message);
            this.content = ''
            this.fileList = []
          });
      }
    },
    next () {
      history.forward();
    },
  },
};
</script>

<style>
</style>
